export default __webpack_public_path__ + "static/media/Warning.5a78821d.svg";